<template>
    <div class="m-shop">
        <div class="m-user"><user-info/></div>

        <div class="shop-view">

            <div class="shop-groups">
                <div class="group-item" v-for="(item,index) in shop_group" :key="index" :class="item.clz" @click="see_offer(item.sid);"></div>
            </div>

            <div class="shop-detail">
                <vuescroll>
                <div class="list-pannel" v-if="shop_list.length">
                    <div class="list-item" v-for="(item,index) in shop_list" :key="item.sid + index">
                        <h5>{{ item.giftName }}*{{ item.sendNum }}</h5>

                        <div class="discount"><em class="tag"></em>{{ shop_dic[item.sid].discount }}</div>

                        <div class="goods-detail">
                            <div class="goods-wrapper">
                                <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                            </div>  
                        </div>

                        <div class="low">最低价<em class="icon-m3b"></em><span class="p-now">{{ item.minPrice }}</span><span class="p-before">{{ item.price }}</span></div>
                        <div class="banner" v-bind:data-sid="'1'" @click="see_offer(item.sid);">{{ shop_dic[item.sid].name }}</div>

                        <div class="u-btn apply" @click="call_cut(item)"></div>
                    </div>
                </div>
                <div class="bottom-img"></div>
                </vuescroll>
            </div>

        </div>
    </div>
</template>

<style lang="scss" scoped>
.m-shop{
    padding-top: 604px;
}

.m-user{
    width: 750px;
    height: 48px;
    line-height: 48px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-userinfo.png);
}

.shop-view{
    position: relative;
    width: 750px;
    height: 2382px;
    margin: 0 auto;
    padding-top: 20px;
    background-image: url(~@/assets/images/shop/bg-shop.png);
}

.shop-groups{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 130px;
    padding: 0 20px;

    .group-item{
        position: relative;
        width: 343px;
        height: 122px;
        background-repeat: no-repeat;
        background-position: top center;

        &.s-1{
            transform: translateY(9px);
            background-image: url(~@/assets/images/shop/shop-1.png);
        }

        &.s-2{
            background-image: url(~@/assets/images/shop/shop-2.png);
        }        
    }
}

.shop-detail{
    height: 90%;

    .bottom-img{
        width: 305px;
        height: 388px;
        margin: 50px auto 50px;
        background-image: url(~@/assets/images/view-bottom.png);
    }
}

.list-pannel{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 18px 20px 20px;

    .empty{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 400px;
        margin-top: 40px;
        padding: 0 30px;
        font-size: 40px;
        font-weight: 700;       
        color: #aa754f;        
        text-align: center;
    }

    .list-item{
        position: relative;
        width: 331px;
        height: 552px;
        padding-top: 42px;
        background-image: url(~@/assets/images/shop/item-pannel.png);
        text-align: center;

        .icon-m3b {
            display: inline-block;
            width: 26px;
            height: 26px;
            background-image: url(~@/assets/images/icon-m3b.png);
            vertical-align: middle;
        }


        h5{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 2.5em;
            margin-bottom: 16px;
            padding: 0 60px;
            font-size: 28px;
            font-weight: 700;
            color: #7f572d;
        }

        .discount{
            margin-bottom: 10px;
            color: #d33d27;
        }

        .low{
            margin-top: 8px;
            color: #7f572d;

            .p-now{
                font-size: 28px;
                font-weight: 700;
                color: #d33d27;
            }

            .p-before {
                padding-left: 8px;
                color: #ad7239;
                text-decoration: line-through;
            }

        }

        .banner {
            width: 283px;
            height: 39px;
            line-height: 39px;
            margin: 15px auto 0;
            text-align: center;
            color: #683d1e;
            background-image: url(~@/assets/images/shop/bg-shopname.png);
        }

        .u-btn.apply{
            position: absolute;
            left: 50%;
            bottom: 62px;
            transform: translateX(-50%);
            width: 232px;
            height: 89px;
            background-image: url(~@/assets/images/shop/btn-apply.png);
        }
    }
}

.goods-detail{
    .goods-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 118px;
        height: 118px;
        margin: 0 auto;
        background-image: url(~@/assets/images/shop/bg-item.png);
    }

    .goods-pic{
        width: 69px;
        height: 69px;
    }
}
</style>

<script>
import shop_group from '@/components/shopgroup.js'

export default {
    data (){
        return {
            shop_list : [],
            shop_group : shop_group.list,
            shop_dic : shop_group.shop_dic,
            sid : 1,
        }
    },
    mounted (){
        this.get_goods_list(this.sid);
    },
    methods : {
        get_goods_list (sid){
            this.$get(ajax_url_map.goods_list,{
                success : (data) => {
                    this.shop_list = data.data.filter((ele) => {
                        return ele.sid != 9;
                    });
                }
            },{
                // sid : sid,
            })
        },
        call_cut(item){

            if(!item.giftId){
                throw new Error('缺少商品ID');
            }

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            this.$post(ajax_url_map.add_basket,{
                success : (data) => {
                    //let shareTxt = data.data.koudai + this.$store.state.userinfo.nickName + '阿斗测试分享' + data.data.shopName + data.data.price + ' ' + data.data.url;
                    let shareTxt = this.$global.share_format({...data.data,nickName : this.$store.state.userinfo.nickName});
                    this.$copy_modal({ shareTxt : shareTxt });
                    this.get_goods_list(this.sid);
                },
                error : (data) => {
                    this.$toast(data.message);
                }                
            },{
                id : item.id,
            })
        },
        see_offer (sid){
            this.$router.push({ name: 'detail', params: { sid: sid }});
        }         
    },
}
</script>